import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { notification } from 'antd';
import api from '../../services/api';
import { Page, Card } from '../Register/styles';
import Button from '../../components/Button';

function DiscordCallback() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchDiscordData = async () => {
      try {
        // Obter o código da URL
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        
        if (!code) {
          setError('Código de autorização não encontrado');
          setLoading(false);
          return;
        }

        // Obter os dados do registro armazenados
        const registerData = JSON.parse(localStorage.getItem('register_data') || '{}');
        
        if (!registerData.username) {
          navigate('/cadastro');
          return;
        }

        // Trocar o código por um token de acesso e obter informações do usuário Discord
        const response = await api.post('/user/auth/discord/callback', { 
          code,
          redirectUri: 'http://localhost:3000/auth/discord/callback'
        });

        // Combinar os dados do Discord com os dados de registro
        if (response.data && response.data.discord) {
          // Armazenar o Discord ID e username completo
          localStorage.setItem('register_data', JSON.stringify({
            ...registerData,
            discord: response.data.discord
          }));

          notification.success({
            message: 'Conta do Discord vinculada com sucesso!',
            description: `Vinculado como ${response.data.discord}`,
            placement: 'bottomRight',
          });

          // Voltar para o registro na etapa 2 com os dados preenchidos
          navigate('/cadastro', { state: { step: 1, discordData: response.data } });
        } else {
          setError('Não foi possível obter os dados do Discord');
        }
      } catch (err) {
        console.error('Erro ao processar autenticação do Discord:', err);
        setError(err.response?.data?.message || 'Erro ao autenticar com o Discord');
      } finally {
        setLoading(false);
      }
    };

    fetchDiscordData();
  }, [navigate, location.search]);

  const handleGoBack = () => {
    navigate('/cadastro');
  };

  return (
    <Page>
      <Card style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
        {loading ? (
          <div>
            <h2>Processando autenticação do Discord...</h2>
            <div className="loading-spinner"></div>
          </div>
        ) : error ? (
          <div>
            <h2>Ocorreu um erro</h2>
            <p>{error}</p>
            <Button backgroundColor="var(--primary)" color="#fff" onClick={handleGoBack}>
              Voltar ao cadastro
            </Button>
          </div>
        ) : (
          <div>
            <h2>Redirecionando...</h2>
            <p>Você será redirecionado de volta à página de cadastro.</p>
          </div>
        )}
      </Card>
    </Page>
  );
}

export default DiscordCallback; 